'use strict';

function rebus() {

    let slideId = 1;

    try {
        goSlides(slideId);
    } catch(e) {}

    function newSlide() {
        goSlides(slideId += 1);
    }

    function goSlides(n) {

        const pics = document.querySelectorAll(".rebus_item");
        let i;

        if (n > pics.length) {
            slideId = 1;
        }

        if (n < 1) {
            slideId = pics.length;
        }

        for (i = 0; i < pics.length; i++) {
            pics[i].style.display = "none";
        }
        
        try{
            pics[slideId - 1].style.display = "block";
        } catch(e) {}
    }

    setInterval(newSlide, 8000);
}

export default rebus;